import type { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import type { ChatRepo } from '@/data/chatRepo';

/**
 * Router context shared by every route. Injected once in `main.tsx` and read
 * by route loaders / components via `Route.useRouteContext()`.
 *
 * `queryClient` powers TanStack Query data access; `chatRepo` is the data seam.
 * The mock→real swap stays isolated to `main.tsx` — components consume the repo
 * exclusively through this context, never importing a concrete implementation.
 */
export interface RouterContext {
  queryClient: QueryClient;
  chatRepo: ChatRepo;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  return <Outlet />;
}
